import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PhxFileUploadComponent } from './phx-file-upload.component';
import { PhxFileComponent } from './phx-file-item/phx-file-item.component';
import { PhxButtonModule } from '../button/phx-button.module';
import { PhxIconButtonModule } from '../icon-button/phx-icon-button.module';
import { PhxIconModule } from '../icon/icon.module';
import { PhxAlertModule } from '../alert-banner/phx-alert.module';
import { PhxGalleryModule } from '../gallery/phx-gallery.module';
import { PhxCarouselModule } from '../carousel/phx-carousel.module';
import { PhxTooltipModule } from '../tooltip/phx-tooltip.module';
import { PhxSpinnerModule } from '../spinner/phx-spinner.module';
import { PhxTranslationsRootModule } from '../../translation/transloco-root.module';
import { PhxTranslatePipe } from '../../translation/phx-translation.pipe';
import { PhxMiddleTruncateModule } from '../middle-truncate/phx-middle-truncate.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@NgModule({
  declarations: [PhxFileUploadComponent, PhxFileComponent],
  imports: [CommonModule, PhxButtonModule, PhxIconButtonModule, PhxIconModule, FormsModule, PhxAlertModule, PhxGalleryModule, PhxCarouselModule, PhxTooltipModule, PhxSpinnerModule, PhxTranslationsRootModule, PhxMiddleTruncateModule, PdfViewerModule],
  exports: [PhxFileUploadComponent, PhxFileComponent],
  providers: [PhxTranslatePipe],
})
export class PhxFileUploadModule { }
